module.exports = __webpack_public_path__ + "img/mixedmartialarts.1fba2f0b.svg";